import { render, staticRenderFns } from "./DashboardChartMeasurements.vue?vue&type=template&id=30569136&scoped=true&"
import script from "./DashboardChartMeasurements.vue?vue&type=script&lang=js&"
export * from "./DashboardChartMeasurements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30569136",
  null
  
)

export default component.exports